import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Barcode from "react-barcode";
import html2canvas from "html2canvas";
import { getBarcodeSettings, updateBarcodeSettings } from "../../../actions/settings";

import {
  Form,
  InputNumber,
  Checkbox,
  Button,
  Col,
  Row,
  message,
  Divider,
  Drawer,
} from "antd";
import { SettingOutlined } from "@ant-design/icons";

const BarcodePrinter = ({ details, variation, getBarcodeSettings, updateBarcodeSettings }) => {
  const wrapper_ref = React.useRef();
  const [settings, setSettings] = useState({
    id: null,
    page_width: 55,
    page_height: 30,
    barcode_height: 40,
    font_size: 12,
    show_product_name: true,
    show_price: true,
    show_business_name: true,
    paper_margin_top: 0,
    paper_margin_bottom: 0,
    paper_margin_left: 0,
    paper_margin_right: 0,
  });
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchSettings();
  }, [getBarcodeSettings]);

  const fetchSettings = () => {
    getBarcodeSettings().then((data) => {
      if (data && data.length > 0) {
        setSettings(data[0]);
        form.setFieldsValue(data[0]);
      }
    });
  }

  const onFinish = (values) => {
    if (settings.id) {
      updateBarcodeSettings(settings.id, values).then((res) => {
        if (res) {
          setSettings(res);
          setVisible(false);
        }
      });
    } else {
      message.error("Settings not found in database. Please add one in Admin first.");
    }
  };

  var formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "BDT",
  });

  const printt = () => {
    const opt = {
      scale: 4,
    };

    const elem = wrapper_ref.current;
    html2canvas(elem, opt).then((canvas) => {
      const iframe = document.createElement("iframe");
      iframe.name = "printf";
      iframe.id = "printf";
      iframe.height = 0;
      iframe.width = 0;
      document.body.appendChild(iframe);

      const imgUrl = canvas.toDataURL({
        format: "jpeg",
        quality: "1.0",
      });
      
      let page = `<div>`;
      page += `<div class="flex-container">
        ${settings.show_business_name ? `<div class="grid-item"><p style="margin: 2px 0; font-size: ${settings.font_size + 2}px; font-weight: 700; letter-spacing: 2px;"><b>SHIRTEX</b></p></div>` : ''}
        <div class="grid-item">
          <p style="margin: 0; font-size: ${settings.font_size - 1}px; letter-spacing: 1px;">
            <b>${variation.product_code}</b>
          </p>
          ${settings.show_product_name ? `
          <p style="margin: 0; font-size: ${settings.font_size - 1}px; letter-spacing: 1px; font-weight: 600;">
            <b>${variation.title} | ${variation.size}</b>
          </p>` : ''}
  
           <img style="display: block; margin: 0px auto; max-width: 100%; height: 50px;" width="160px" src="${imgUrl}"/>    
        </div>
        ${settings.show_price ? `<div class="grid-item"><p style="margin: -7px 0 0 0; font-size: ${settings.font_size}px; font-weight: 700;"><b>${formatter.format(
          variation.selling_price
        )}</b></p></div>` : ''} 
       `;
      page += "</div></div>"

      var newWin = window.frames["printf"];
      newWin.document.write(
        `<body onload="window.print()"><style>
        @page { 
          size: ${settings.page_width}mm ${settings.page_height}mm; 
          margin: ${settings.paper_margin_top}mm ${settings.paper_margin_right}mm ${settings.paper_margin_bottom}mm ${settings.paper_margin_left}mm; 
        }
        body {
          margin: 0;
          padding: 0;
        }
        
.flex-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${settings.page_width}mm;
  height: ${settings.page_height}mm;
  box-sizing: border-box;
  overflow: hidden;
  text-align: center;
}

.grid-item {
  width: 100%;
  font-size: ${settings.font_size - 2}px;
  text-align: center;
  margin: 0;
}

        </style>${page}</body>`
      );
      newWin.document.close();
      return page;
    });
  };

  return (
    <>
      <div style={{ display: 'flex', gap: '0px', alignItems: 'center' }}>
        <div ref={wrapper_ref}>
          <Barcode 
            width={2} 
            height={settings.barcode_height} 
            fontSize={settings.font_size} 
            format="CODE128" 
            value={variation.barcode} 
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <Button type="primary" onClick={printt}>Print Barcode</Button>
          <Button icon={<SettingOutlined />} onClick={() => setVisible(true)}>Settings</Button>
        </div>
      </div>

      <Drawer
        title="Barcode Print Settings"
        placement="right"
        onClose={() => setVisible(false)}
        visible={visible}
        width={400}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={settings}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="page_width" label="Page Width (mm)">
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="page_height" label="Page Height (mm)">
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="barcode_height" label="Barcode Height">
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="font_size" label="Font Size">
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>

          <Divider orientation="left">Margins (mm)</Divider>
          <Row gutter={8}>
            <Col span={6}>
              <Form.Item name="paper_margin_top" label="Top">
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="paper_margin_right" label="Right">
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="paper_margin_bottom" label="Bottom">
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="paper_margin_left" label="Left">
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>

          <Divider orientation="left">Visibility</Divider>
          <Form.Item name="show_business_name" valuePropName="checked">
            <Checkbox>Show Business Name</Checkbox>
          </Form.Item>
          <Form.Item name="show_product_name" valuePropName="checked">
            <Checkbox>Show Product Name/Size</Checkbox>
          </Form.Item>
          <Form.Item name="show_price" valuePropName="checked">
            <Checkbox>Show Price</Checkbox>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Save Settings
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};

export default connect(null, { getBarcodeSettings, updateBarcodeSettings })(BarcodePrinter);